const translations = {
  'teachingYoungLearners.seo.title': 'Teaching Young Learners TEFL Course in Barcelona',
  'teachingYoungLearners.seo.description':
    'Learn how to teach kids from ages 5 to 16 with our practical young learners course. Real teaching practice and feedback with kids and teens.',
};

export default translations;
